/**
 * Motion defaults to ~300ms tweens; root `transition: { delay }` also applies to whileHover/whileTap,
 * which reads as input lag. Stagger only opacity/x/y on enter; keep scale gestures snappy.
 */
export const snappyTween = { type: 'tween', duration: 0.1, ease: [0.25, 0.1, 0.25, 1] };

export function staggerEntrance(i, step = 0.05, base = 0) {
  const d = base + i * step;
  return {
    opacity: { delay: d, duration: 0.18, ease: 'easeOut' },
    y: { delay: d, duration: 0.18, ease: 'easeOut' },
    x: { delay: d, duration: 0.18, ease: 'easeOut' },
    scale: snappyTween
  };
}
